<template>
  <!-- 2 row -->
  <v-layout row wrap justify-center v-if="type_richmenu === 1">
    <v-flex v-for="(item, index) in list_menu" :key="index" xs4 md4 sm4 md4 lg4 xl4 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="item.picture"
          aspect-ratio="1.5"
          height="125px"
          @click="sendrichmenu(item, index)"
        >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 2">
    <v-flex v-for="(item, index) in list_menu" :key="index" xs6 md6 sm6 md6 lg6 xl6 class="pa-0">
      <v-card>
        <v-img
          class="cursor"
          cover
          :src="item.picture"
          aspect-ratio="1.5"
          height="125px"
          @click="sendrichmenu(item, index)"
        >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 3">
    <v-flex xs12 md12 sm12 md12 lg12 xl12 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="list_menu[0].picture"
          aspect-ratio="3"
          height="125px"
          @click="sendrichmenu(list_menu[0], 0)"
        >
        </v-img>
      </v-card>
    </v-flex>
    <v-flex v-for="(item, index) in list_menu" :key="index" xs4 md4 sm4 md4 lg4 xl4 class="pa-0" v-if="index !== 0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="item.picture"
          aspect-ratio="1"
          height="125px"
          @click="sendrichmenu(item, index)"
        >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 4">
    <v-flex xs8 md8 sm8 md8 lg8 xl8 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="list_menu[0].picture"
          aspect-ratio="1"
          height="250px"
          @click="sendrichmenu(list_menu[0], 0)"
        >
        </v-img>
      </v-card>
    </v-flex>
    <v-flex xs4 md4 sm4 md4 lg4 xl4 class="pa-0">
      <v-card>
        <v-layout column>
          <v-flex v-for="(item, index) in list_menu" :key="index" v-if="index !== 0" xs12 md12 sm12 md12 lg12 xl12 class="pa-0">
            <v-card>
              <v-img
                cover
                class="cursor"
                height="125px"
                :src="item.picture"
                aspect-ratio="1"
                @click="sendrichmenu(item, index)"
              >
              </v-img>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 5">
    <v-flex v-for="(item, index) in list_menu" :key="index" xs12 md12 sm12 md12 lg12 xl12 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          height="125px"
          :src="item.picture"
          aspect-ratio="3"
          @click="sendrichmenu(item, index)"
        >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-start v-else-if="type_richmenu === 6">
    <v-flex v-for="(item, index) in list_menu" :key="index" xs6 md6 sm6 md6 lg6 xl6 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="item.picture"
          height="250px"
          aspect-ratio="1.3"
          cover
          @click="sendrichmenu(item, index)"
        >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 7">
    <v-flex xs12 md12 sm12 md12 lg12 xl12 class="pa-0">
      <v-card class="cursor object-fit_fill">
        <v-img
          cover
          class="cursor object-fit_fill"
          :src="list_menu[0].picture"
          aspect-ratio="1.5"
          height="250px"
          @click="sendrichmenu(list_menu[0], 0)"
        >
        </v-img>
        <!-- <img class="object-fit_fill" height="250px" width="100%" aspect-ratio="1.5" :src="list_menu[0].picture"> -->
      </v-card>
    </v-flex>
  </v-layout>
  <!-- 1 row -->
  <v-layout row wrap justify-center v-else-if="type_richmenu === 8">
    <v-flex v-for="(item, index) in list_menu" :key="index" xs4 md4 sm4 md4 lg4 xl4 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="item.picture"
          aspect-ratio="1"
          height="125px"
          @click="sendrichmenu(item, index)"
        >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 9">
    <v-flex xs4 md4 sm4 md4 lg4 xl4 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="list_menu[0].picture"
          aspect-ratio="1"
          height="125px"
          @click="sendrichmenu(list_menu[0], 0)"
        >
        </v-img>
      </v-card>
    </v-flex>
    <v-flex xs8 md8 sm8 md8 lg8 xl8 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="list_menu[1].picture"
          aspect-ratio="1"
          height="125px"
          @click="sendrichmenu(list_menu[1], 1)"
          >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 10">
    <v-flex xs8 md8 sm8 md8 lg8 xl8 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="list_menu[0].picture"
          aspect-ratio="1"
          height="125px"
          @click="sendrichmenu(list_menu[0], 0)"
          >
        </v-img>
      </v-card>
    </v-flex>
    <v-flex xs4 md4 sm4 md4 lg4 xl4 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="list_menu[1].picture"
          aspect-ratio="1"
          height="125px"
          @click="sendrichmenu(list_menu[1], 1)"
          >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 11">
    <v-flex v-for="(item, index) in list_menu" xs6 md6 sm6 md6 lg6 xl6 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="item.picture"
          aspect-ratio="1.5"
          height="125px"
          @click="sendrichmenu(item, index)"
          >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 12">
    <v-flex xs12 md12 sm12 md12 lg12 xl12 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="list_menu[0].picture"
          aspect-ratio="3"
          height="125px"
          @click="sendrichmenu(list_menu[0], 0)"
        >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 13">
    <v-flex v-for="(item, index) in list_menu" :key="index" xs3 md3 sm3 md3 lg3 xl3 class="pa-0">
      <v-card>
        <v-img
          class="cursor"
          cover
          :src="item.picture"
          aspect-ratio="1.5"
          height="125px"
          @click="sendrichmenu(item, index)"
        >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>

</template>

<script>
export default {
  props: {
    Richmenudialog: false,
    inforrichmenu: {},
    type_richmenu: Number
  },
  data () {
    return {
      // type_richmenu: '6'
      list_menu: []
    }
  },
  created () {
    // console.log(this.inforrichmenu)
    // console.log(this.type_richmenu)
    this.list_menu = this.inforrichmenu
    // console.log(this.list_menu)
  },
  methods: {
    sendrichmenu (item, index) {
      // console.log(item)
      // console.log(index)
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0')
      var hour = String(today.getHours() + 1).padStart(2, '0')
      var minute = String(today.getMinutes()).padStart(2, '0')
      var seconds = String(today.getSeconds()).padStart(2, '0')
      var milsec = today.getMilliseconds()
      var mm = String(today.getMonth() + 1).padStart(2, '0')
      var yyyy = today.getFullYear()
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00'
        dd = String(today.getDate() + 1).padStart(2, '0')
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1'
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1'
            yyyy = today.getFullYear() + 1
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0')
            // console.log(mm)
          }
        }
      }
      // else {
      //   dd = String(today.getDate()).padStart(2, '0')
      // }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
      // console.log(today)

      this.$emit('emitrichmenu', { infor: this.inforrichmenu[index], expired_date: today })
    }
  },
  watch: {
  }
}
</script>

<style lang="css" scoped>
.image {
  float: left;
  width: 40%;
  margin: 0 30px 20px 0;

  &:nth-child(2n) {
    clear: left;
  }

  &:nth-child(2n+1){
    margin-right: 0;
  }
}
.object-fit_fill {
   object-fit: fill
}
/* >>>.v-responsive .v-image {
  height: 100% !important;
} */
.cursor {
  cursor: pointer;
}
>>>.v-card__text {
  padding: 10px;
  width: 100%;
}
>>>.v-card {
  display: block;
  border-radius: 2px;
  min-width: 0;
  position: relative;
  text-decoration: none;
  transition: .3s cubic-bezier(.25,.8,.5,1) !important;
  box-shadow: none !important;
}
>>>.mx-auto .v-card .theme--dark {
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/richmenu/Richmenudialog.vue